<template>
  <AppDialog :is-open="isDialogOpened"
             :ok-loading="renameEnvelopeTemplatePending"
             :cancel-disabled="renameEnvelopeTemplatePending"
             @ok="prepareRenameEnvelopeTemplate"
             @cancel="closeDialog"
  >
    <template #title>{{ $t('project.signing-checklist.envelope-templates.dialogs.RenameDialog.title') }}</template>
    <template #body>
      <form @submit.prevent="prepareRenameEnvelopeTemplate">
        <AppTextField v-model="v$.newName.$model"
                      :label="$t('project.signing-checklist.envelope-templates.dialogs.RenameDialog.labelName')"
                      :counter="MAX_NAME_LENGTH"
                      maxLength="100"
                      :error-messages="newNameErrors"
        />
      </form>
    </template>
  </AppDialog>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { maxLength, required } from '@vuelidate/validators'
import { mapActions, mapState } from 'vuex'

import AppTextField from '@/common/AppTextField.vue'
import AppDialog from '@/common/dialogs/AppDialog.vue'
import { formFieldErrors } from '@/common/utils/form'
import { toast } from '@/common/utils/toast'
import { dialogMixin } from '@/mixins/dialogMixin'
const MAX_NAME_LENGTH = 100
export default {
  name: 'RenameDialog',
  components: { AppTextField, AppDialog },
  mixins: [dialogMixin],
  setup: () => ({ v$: useVuelidate() }),
  validations: {
    newName: { required, maxLength: maxLength(MAX_NAME_LENGTH) },
  },
  props: {
    envelopeTemplate: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      MAX_NAME_LENGTH,
      newName: this.envelopeTemplate.title,
    }
  },
  computed: {
    ...mapState('envelopeTemplates', ['renameEnvelopeTemplatePending']),
    newNameErrors () {
      return formFieldErrors(
          this.v$.newName,
          [
            ['required', this.$t('common.validations.fieldRequired', { fieldName: this.$t('project.signing-checklist.envelope-templates.dialogs.RenameDialog.labelName') })],
            ['maxLength', this.$t('common.validations.maxLength', { fieldName: this.$t('project.signing-checklist.envelope-templates.dialogs.RenameDialog.labelName'), maxLength: MAX_NAME_LENGTH })],
          ],
      )
    },
  },
  methods: {
    ...mapActions('envelopeTemplates', ['RENAME_ENVELOPE_TEMPLATE']),
    async prepareRenameEnvelopeTemplate () {
      this.v$.$touch()
      if (!this.v$.$invalid) {
        try {
          await this.RENAME_ENVELOPE_TEMPLATE({
            envelopeTemplateId: this.envelopeTemplate.id,
            data: {
              title: this.newName,
            },
          })
          this.closeDialog()
        } catch (error) {
          toast.error(this.$t('project.signing-checklist.envelope-templates.dialogs.RenameDialog.renameEnvelopeTemplateError'))
        }
      }
    },
  },
}
</script>
